angular.module('unica_campaign_template.campaign_template_services')

.factory('CampaignTemplatePreviewService', function($http, getBaseApiURL) {

	var campaignTemplatePreviewService = {};

	campaignTemplatePreviewService.preview = function (id, userId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/campaign-template/preview/' + id,
			data: {
				user_id: userId
			}
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};


	campaignTemplatePreviewService.previewSimulate = function (id, invId, destId)
	{
		console.log( invId );
		console.log('a');
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/campaign-template/preview-simulate/' + id,
			data: {
				inv_id: invId,
				dest_id: destId
			}
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};

	return campaignTemplatePreviewService;

});